<template>
  <v-list-item-content>
    <v-list-item-title v-if="!!contentRender"> 
      <Render 
        :target="target"
        :value="value"
        :header="header"
        :render="contentRender"
      />
    </v-list-item-title>
    <v-list-item-title v-if="!contentRender"> 
      {{ value }}
    </v-list-item-title>
    <v-list-item-subtitle v-if="!!labelRender">
      <Render 
        :target="target"
        :value="value"
        :header="header"
        :render="contentRender"
      />
    </v-list-item-subtitle>
    <v-list-item-subtitle v-if="!labelRender">
      {{ label }}
    </v-list-item-subtitle>
  </v-list-item-content>
</template>
<script>
  import { VAutocomplete } from 'vuetify/lib'
  const Render = {
    props: {
      render: {
        type: Function
      },
      value: {
        type: [String, Number, Object]  
      },
      target: {
        type: [String, Number, Object]  
      },
      header: {
        type: Object
      }
    },
    render(h) {
      return this.render(h, this.value, this.header, this.target)
    }
  }
  export default {
    components: {
      VAutocomplete,
      Render
    },
    props: {
      label: {
        type: [String, Number, Object]    
      },
      value: {
        type: [String, Number, Object] 
      },
      contentRender: {
        type: Function
      },
      labelRender: {
        type: Function
      },
      propsg: {
        type: Object,
        default: () => ({}),
      },
      callBacks: {
        type: Function
      },
      target: {
        type: Object,
      },
      header: {
        type: Object,
      }
    },
    data() {
      return {
        search_:''
      };
    },
    watch: {

    },
    mounted() {
      // console.log('this', this.target)
    }
  }
</script>
    